import { useUserType } from './useUserType';

/**
 * This hook is used to check if the user is in the PayShip experiment for the buyer scenario(eg. VIP, SRP, HeaderMenu, etc.).
 * Seller scenario(eg. SYI, My Ads, etc.) should use GrowthBookFeature.PAY_SHIP_SELLER
 * The experiments have now been taken offline. All users except PRO can see payship feature
 */
export function useShowPayShipFeature() {
    try {
        const userType = useUserType();

        return userType === 'STANDARD';
    } catch (_) {
        return false;
    }
}
